import DeptSelect from './dept_select'

export default {
  install: (Vue) => {
    Vue.component('dept-select', DeptSelect)
  }
}